jQuery(function ($) {

    var domain = window.location.origin;

    if (domain.indexOf("inr") >= 0) {
        Sentry.init({
            dsn: "https://2f52bd8b0c6047bf948fe34ffd6bfe33@o444765.ingest.sentry.io/5618096",
            integrations: [new Sentry.Integrations.BrowserTracing()],
            tracesSampleRate: 1.0,
        });
    }
});